"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTENTION_AUDIT_LOG_EVENT_TYPES = exports.MAX_INTENTIONS = void 0;
/** Maximum number of active intentions in the dictionary. */
exports.MAX_INTENTIONS = 5;
/** Audit log event types related to the intentions feature. */
exports.INTENTION_AUDIT_LOG_EVENT_TYPES = ['createIntention', 'updateIntention', 'deleteIntention', 'setUserIntention', 'clearUserIntention', 'reorderIntentions'];
//# sourceMappingURL=intention.constants.js.map